"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var scroll_into_view_if_needed_1 = tslib_1.__importDefault(require("scroll-into-view-if-needed"));
var call_both_1 = require("../_util/call-both");
var config_context_1 = require("../_util/config-context");
var badge_1 = require("../badge");
var icon_1 = require("../icon");
var uuid_1 = require("../_util/uuid");
var MenuContext_1 = require("./MenuContext");
var noop_1 = require("../_util/noop");
var is_child_of_type_1 = require("../_util/is-child-of-type");
var util_1 = require("../util");
var defaultRender = function (children) { return react_1.default.createElement("a", null, children); };
exports.MenuItem = react_1.forwardRef(function MenuItem(_a, fRef) {
    var title = _a.title, icon = _a.icon, tag = _a.tag, selected = _a.selected, external = _a.external, className = _a.className, _b = _a.onClick, onClick = _b === void 0 ? noop_1.noop : _b, _c = _a.render, render = _c === void 0 ? defaultRender : _c, props = tslib_1.__rest(_a, ["title", "icon", "tag", "selected", "external", "className", "onClick", "render"]);
    var ref = react_1.useRef(null);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var setMobileCollapsed = react_1.useContext(MenuContext_1.MenuContext).setMobileCollapsed;
    var _d = react_1.useContext(MenuContext_1.SubMenuContext), inSubMenu = _d.inSubMenu, onSelectedChange = _d.onSelectedChange, onTagChange = _d.onTagChange;
    var idRef = react_1.useRef(uuid_1.uuid());
    react_1.useEffect(function () {
        if (ref.current && selected) {
            scroll_into_view_if_needed_1.default(ref.current, {
                scrollMode: "if-needed",
                block: "nearest",
                inline: "nearest",
            });
        }
    }, [ref, selected]);
    react_1.useEffect(function () {
        onTagChange(idRef.current, !!tag);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag]);
    react_1.useEffect(function () { return function () {
        onTagChange(idRef.current, false);
    }; }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    react_1.useEffect(function () {
        onSelectedChange(idRef.current, selected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);
    var tagBadge = react_1.useMemo(function () { return (is_child_of_type_1.isChildOfType(tag, badge_1.Badge) ? tag : react_1.default.createElement(badge_1.Badge, null, tag)); }, [tag]);
    var _e = tslib_1.__read(Array.isArray(icon) ? icon : [icon, icon], 2), defaultIcon = _e[0], activeIcon = _e[1];
    var children = render(react_1.default.createElement(react_1.default.Fragment, null,
        defaultIcon &&
            !inSubMenu &&
            (typeof defaultIcon === "string" ? (react_1.default.createElement("img", { className: classPrefix + "-menu__list-icon", src: defaultIcon, alt: "icon" })) : (defaultIcon)),
        activeIcon &&
            !inSubMenu &&
            (typeof activeIcon === "string" ? (react_1.default.createElement("img", { className: classPrefix + "-menu__list-icon is-selected", src: activeIcon, alt: "icon" })) : (activeIcon)),
        react_1.default.createElement("div", { className: classPrefix + "-menu__text" },
            title,
            external && react_1.default.createElement(icon_1.Icon, { type: "externallink" })),
        !!tag && tagBadge));
    return (react_1.default.createElement("li", tslib_1.__assign({ ref: util_1.mergeRefs(fRef, ref), className: classnames_1.default(className, { "is-selected": selected }), onClick: function () { return setMobileCollapsed(false); } }, props), react_1.default.cloneElement(children, {
        className: classnames_1.default(classPrefix + "-menu__item", children.props.className),
        onClick: call_both_1.callBoth(onClick, children.props.onClick),
    })));
});
exports.MenuItem.displayName = "MenuItem";
//# sourceMappingURL=MenuItem.js.map